module.exports = __webpack_public_path__ + "static/media/ROISEC_Logotype_RGB.8e054304.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ROISEC_Logotype_RGB.png
// module id = 1430
// module chunks = 0